import * as React from 'react';

import {CheckboxForGroup} from 'shells/checkbox/checkbox-for-group';
import {CheckboxGroup} from 'shells/checkbox/checkbox-group';
import {FormField} from 'shells/form/form-field';
import {Illustration} from 'shells/illustrations/illustration';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {RadioButton} from 'shells/radio/radio-button';
import {RadioGroup} from 'shells/radio/radio-group';

import type {GetStagesets_stagesets as Stageset} from 'nutshell-graphql-types';

import {PIPELINE_SELECT_OPTIONS, PIPELINE_TYPE_SPECIFIC} from './create-or-edit-modal';

import styles from '../custom-fields.module.css';

type Props = {
    selectedEntity: string;
    selectedPipelineType: string;
    setSelectedPipelineType: (pipelineType: string) => void;
    selectedStagesets: string[];
    setSelectedStagesets: (stagesets: string[]) => void;
    stagesets: Stageset[];
    isEditing: boolean;
};

export function RightSection(props: Props) {
    const showPipelinesSection =
        props.selectedEntity === 'Leads' && !NutClientConfig.hasLeadPageRedesignM3FF;

    return showPipelinesSection ? (
        <StackLegacy spacing={16}>
            <FormField
                innerId='pipelineField'
                label='Which pipeline should this field be shown in?'
                noMargin={true}
            >
                <RadioGroup
                    name='buttons'
                    selectedValue={props.selectedPipelineType}
                    onChange={(newVal) => {
                        props.setSelectedPipelineType(newVal);
                        if (newVal === PIPELINE_TYPE_SPECIFIC && props.isEditing) {
                            props.setSelectedStagesets(
                                props.stagesets.map((stageset) => stageset.id)
                            );
                        }
                    }}
                >
                    {PIPELINE_SELECT_OPTIONS.map((option) => (
                        <RadioButton value={option.value} key={option.value}>
                            {option.label}
                        </RadioButton>
                    ))}
                </RadioGroup>
            </FormField>
            {props.selectedPipelineType === PIPELINE_TYPE_SPECIFIC && (
                <FormField innerId='stagesetField' label='' noMargin={true}>
                    <div className={styles['pipeline-checkboxes']}>
                        <CheckboxGroup
                            name='stagesets'
                            selectedValues={props.selectedStagesets}
                            onChange={(newVal) => props.setSelectedStagesets(newVal)}
                        >
                            {props.stagesets.map((stageset) => (
                                <CheckboxForGroup value={stageset.id} key={stageset.id}>
                                    {stageset.name}
                                </CheckboxForGroup>
                            ))}
                        </CheckboxGroup>
                    </div>
                </FormField>
            )}
        </StackLegacy>
    ) : (
        <Illustration src='custom-fields' />
    );
}
